import { StyleSheet, Text, View } from '@react-pdf/renderer'
import { ImagePageHeader } from 'pages/reporting/reports/rug/components/ImagePageHeader'
import { useRugReportOps } from 'pages/reporting/reports/rug/RugReportProvider'
import { PageFooter } from 'pages/reporting/shared/pdfGeneration/components/shared/PageFooter'
import { PageHeader } from 'pages/reporting/shared/pdfGeneration/components/shared/PageHeader'
import { ReportPage } from 'pages/reporting/shared/pdfGeneration/components/shared/ReportPage'
import React, { useMemo } from 'react'

interface AddendumPagesProps {
  sectionId: string
  sectionTitle: string
}

const pageStyles = StyleSheet.create({
  addendumPage: {
    minHeight: '100%',
  },
})

/**
 * Component to render addendum blank pages for a specific section
 * Filters and displays only addendums that match the given section ID
 */
export const AddendumPages: React.FC<AddendumPagesProps> = ({
  sectionId,
  sectionTitle,
}) => {
  const { formData } = useRugReportOps()

  const addendumsForSection = useMemo(() => {
    if (!formData.sectionAddendums) return []

    return formData.sectionAddendums.filter(
      (addendum) => addendum.sectionId === sectionId
    )
  }, [formData.sectionAddendums, sectionId])

  if (addendumsForSection.length === 0) {
    return null
  }

  return (
    <>
      {addendumsForSection.map((addendum, addendumIndex) =>
        Array.from({ length: addendum.addedPageCount }).map((_, pageIndex) => (
          <ReportPage
            key={`${addendumIndex}-${pageIndex}`}
            size='LETTER'
            orientation='landscape'
            pageStyle={pageStyles.addendumPage}
            header={<PageHeader title={sectionTitle} />}
            footer={
              <PageFooter
                jobNumber={formData.mainInfo.assetId}
                revisionNumber={formData.revisionMetadata.revisionNumber}
              />
            }>
            <ImagePageHeader />
            {addendum.pageSubtitle && (
              <View style={{ marginBottom: 8 }}>
                <Text
                  style={{
                    fontSize: 10,
                    fontWeight: 'bold',
                    color: '#2e5266',
                  }}>
                  {addendum.pageSubtitle}
                </Text>
              </View>
            )}
          </ReportPage>
        ))
      )}
    </>
  )
}
